import React, { Component } from 'react';
import { Table, Column, Cell } from 'components/Table';

import Score from 'components/Score';

import '../../sass/components/ui-list';
import 'components/PhonemeFarmMetrics/phonemeFarmMetrics.scss';

import {sortMetrics, metricsForPF, getPercent, getText} from '../util/metrics';

export class LessonCell extends Component{
    render (){
        return (
            <Cell>{this.props.item.name}</Cell>
        );
    }
}

export class SoundFarmCell extends Component{
    render (){
        let soundfarm1 = this.props.item.soundfarm1 ? this.props.item.soundfarm1 + '%' : '';
        const soundfarm1json = this.props.item.soundfarm1json;

        if (soundfarm1json) {
            return (
                <Cell className="score-cell align-center">
                    <Score
                        value={getPercent(soundfarm1json.score, soundfarm1json.outOf)}
                        text={getText(soundfarm1json.score, soundfarm1json.outOf)}
                        boxClass="metrics-box-color"
                    />
                </Cell>
            );
        }
        return (
            <Cell className="score-cell align-center">
                <Score
                    value={this.props.item.soundfarm1}
                    text={soundfarm1}
                    boxClass="metrics-box-color"
                />
            </Cell>
        );
    }
}

export class SingleSoundActivityCell extends Component{
    render(){
        let value = this.props.item[this.props.field];
        const valuejson = this.props.item[`${this.props.field}json`]; // allow for data to be backwards compatible

        if (valuejson) {
            return (
                <Cell className="score-cell align-center">
                    <Score
                        value={getPercent(valuejson.score, valuejson.outOf)}
                        text={getText(valuejson.score, valuejson.outOf)}
                        boxClass="metrics-box-color"
                    />
                </Cell>
            );
        }
        return(
            <Cell className="score-cell align-center">
                <Score
                    value={value}
                    text={`${value} %`}
                    boxClass="metrics-box-color"
                />
            </Cell>
        );
    }
}

export class DoubleSoundActivityCell extends Component{
    render(){
        let value1 = this.props.item[this.props.field1];
        let value2 = this.props.item[this.props.field2];

        const value1json = this.props.item[`${this.props.field1}json`];
        const value2json = this.props.item[`${this.props.field2}json`];

        if (value1json || value2json) {
            return(
                <Cell className="score-cell align-center">
                    <Score
                        value={getPercent(value1json.score, value1json.outOf)}
                        text={getText(value1json.score, value1json.outOf)}
                        boxClass="metrics-box-color"
                    />
                    <span className="score-spacer"></span>
                    <Score
                        value={getPercent(value2json.score, value2json.outOf)}
                        divisor={value1json.outOf}
                        text={getText(value2json.score, value2json.outOf)}
                        boxClass="metrics-box-color"
                    />
                </Cell>
            );
        }

        return(
            <Cell className="score-cell align-center">
                <Score
                    value={value1}
                    text={`${value1} %`}
                    boxClass="metrics-box-color"
                />
                <span className="score-spacer"></span>
                <Score
                    value={value2}
                    divisor={this.props.divisor2}
                    text={`${value2} %`}
                    boxClass="metrics-box-color"
                />
            </Cell>
        );
    }
}

export class SingleSoundGameTable extends Component{
    render(){
        return (
            <Table
                data={this.props.data}
                includeHeader={false}
            >
                <Column
                    col="lesson"
                    tooltip={true}
                    cell={<LessonCell/>}
                />
                <Column
                    col="soundfarm1"
                    tooltip={true}
                    cell={<SoundFarmCell/>}
                />
                <Column
                    col={this.props.col}
                    cell={<SingleSoundActivityCell
                        field={this.props.field}
                    />}
                />
            </Table>
        );
    }
}

export class DoubleSoundGameTable extends Component{
    render(){
        return (
            <Table
                data={this.props.data}
                includeHeader={false}
            >
                <Column
                    col="lesson"
                    tooltip={true}
                    cell={<LessonCell/>}
                />
                <Column
                    col="soundfarm1"
                    tooltip={true}
                    cell={<SoundFarmCell/>}
                />
                <Column
                    col={this.props.col}
                    cell={<DoubleSoundActivityCell
                        field1={this.props.field1}
                        field2={this.props.field2}
                    />}
                />
            </Table>
        );
    }
}

export default class PhonemeFarmMetricsList extends Component {

    constructor (props) {
        super(props);
    }

    render () {
        // We're sorting otherwise lesson 10 appears beween 1 and 2
        let metricsArr = this.props.student.metrics ? this.props.student.metrics : [];
        let metrics = sortMetrics(metricsArr);
        let data = metricsForPF(metrics);

        return (
            <div className="main-list-area">
                <div className="lesson-content sticky">
                    <div className="lesson-header">
                        Target/Activity
                    </div>
                    <div className="lesson-data">
                        <div className="ui-list">
                            <div className="list-row">
                                <Cell>Lesson/Phoneme</Cell>
                                <Cell className="align-center">Sound Farm<br/>Passed first attempt</Cell>
                                <Cell className="align-center">Sound Game<br/>Passed first attempt</Cell>
                            </div>
                        </div>
                    </div>
                </div>
                {data.tractor.length > 0 &&
                    (<div className="lesson-content">
                        <div className="lesson-header">
                            Lesson 1-5<br/>Initial Vowel<br/>Tractor
                        </div>
                        <div className="lesson-data">
                            <SingleSoundGameTable
                                data={data.tractor}
                                col="tractor1"
                                field='tractor1'
                            />
                        </div>
                    </div>)
                }
                {data.horse.length > 0 &&
                    (<div className="lesson-content">
                        <div className="lesson-header">
                            Lesson 6-14<br/>Initial Consonant<br/>Horseshoe
                        </div>
                        <div className="lesson-data">
                            <SingleSoundGameTable
                                data={data.horse}
                                col="horse1"
                                field='horse1'
                            />
                        </div>
                    </div>)
                }
                {data.apple.length > 0 &&
                    (<div className="lesson-content">
                            <div className="lesson-header">
                                Lesson 15-24<br/>Initial Consonant<br/>Apple
                            </div>
                            <div className="lesson-data">
                                <SingleSoundGameTable
                                    data={data.apple}
                                    col="apple1"
                                    field='apple1'
                                />
                            </div>
                        </div>)
                }
                {data.sheep.length > 0 &&
                    (<div className="lesson-content">
                        <div className="lesson-header">
                            Lesson 25-32<br/>Final Consonant<br/>Sheep
                        </div>
                        <div className="lesson-data">
                            <SingleSoundGameTable
                                data={data.sheep}
                                col="sheep1"
                                field='sheep1'
                            />
                        </div>
                    </div>)
                }
                {data.popcorn.length > 0 &&
                    (<div className="lesson-content">
                        <div className="lesson-header">
                            Lesson 33-40<br/>Final Consonant<br/>Popcorn
                        </div>
                        <div className="lesson-data">
                            <SingleSoundGameTable
                                data={data.popcorn}
                                col="popcorn1"
                                field='popcorn1'
                            />
                        </div>
                    </div>)
                }
                {data.egghay.length > 0 &&
                    (<div className="lesson-content">
                        <div className="lesson-header">
                            Lesson 41-45<br/>Final Consonant<br/>Egg/Hay
                        </div>
                        <div className="lesson-data">
                            <DoubleSoundGameTable
                                data={data.egghay}
                                col1="egg1"
                                field1="egg1"
                                col2="hay1"
                                field2="hay1"
                            />
                        </div>
                    </div>)
                }
                {data.manipulation.length > 0 &&
                    (<div className="lesson-content">
                        <div className="lesson-header">
                            Dunk Tank
                        </div>
                        <div className="lesson-data">
                            <SingleSoundGameTable
                                data={data.manipulation}
                                col="manipulation1"
                                field='manipulation1'
                            />
                        </div>
                    </div>)
                }
                {data.deletion.length > 0 &&
                    (<div className="lesson-content">
                        <div className="lesson-header">
                            Milk Bottle Toss
                        </div>
                        <div className="lesson-data">
                            <SingleSoundGameTable
                                data={data.deletion}
                                col="deletion1"
                                field='deletion1'
                            />
                        </div>
                    </div>)
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./js/components/PhonemeFarmMetricsList.js